import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { useWSMutation } from "../../helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import { QUERY_CARD } from "../queries/useQueryCard";
import { QUERY_CARDS } from "../queries/useQueryCards";
import { updatePIN } from "../../../services/api/banking/cards/updatePIN";

export const useMutationSetPINCard = () =>
  useWSMutation<
    cardApiSpec.Card,
    WSServiceError,
    {
      cardId: string;
    } & cardApiSpec.SetPinRequest
  >(
    ({ cardId, ...request }) => {
      return updatePIN(cardId, request);
    },
    {
      dependencies(response, { cardId }) {
        return [[QUERY_CARD, cardId], QUERY_CARDS];
      }
    }
  );
